export default function () {
  $(".mentees-ajax-select2").select2({
    placeholder: $(this).data("placeholder"),
    theme: "bootstrap",
    minimumInputLength: 3,
    ajax: {
      url: "/admin/mentees/search",
      dataType: "json",
      delay: 250,
      data: (params) => ({
        q: params.term,
        page: params.page || 1,
      }),
    },
  });
  $(".cities-ajax-select2").select2({
    placeholder: $(this).data("placeholder"),
    theme: "bootstrap",
    minimumInputLength: 2,
    ajax: {
      url: "/admin/cities/search",
      dataType: "json",
      delay: 250,
      data: (params) => ({
        q: params.term,
        page: params.page || 1,
      }),
    },
  });
  $(".select2-selector").select2({
    placeholder: $(this).data("placeholder"),
    theme: "bootstrap",
    width: "element",
  });
  $("[data-behavior~=campus-search-select2]")
    .select2({
      placeholder: $(this).data("placeholder"),
      theme: "bootstrap",
      minimumInputLength: 3,
      ajax: {
        url: "/admin/campuses",
        dataType: "json",
        delay: 250,
        data: (params) => ({
          q: params.term,
          page: params.page || 1,
        }),
        processResults: function (data) {
          return {
            results: data.table.data.map((item) => ({
              id: item.id,
              text: item.name,
            })),
            pagination: {
              more: data.table.facets.table.next_page,
            },
          };
        },
      },
      tags: true,
      createTag: function (params) {
        const term = (params.term || "").trim();
        if (term.length < 3) {
          return null;
        }
        return {
          id: `__new__:${term}`,
          text: `Create \"${term}\"`,
          isNew: true,
          realText: term,
        };
      },
      templateSelection: function (data) {
        return data.realText || data.text;
      },
    })
    .on("select2:select", function (e) {
      const data = e.params.data;
      if (data.id && String(data.id).startsWith("__new__:")) {
        const selectEl = $(this);
        const realName =
          data.realText || data.text.replace(/^Create \"|\"$/g, "");
        const cityId = $("#sales_intern_city_id").val();
        $.ajax({
          url: "/admin/campuses",
          method: "POST",
          dataType: "json",
          headers: {
            "X-CSRF-Token": $("meta[name=csrf-token]").attr("content"),
          },
          data: { campus: { name: realName, city_id: cityId } },
          success: function (resp) {
            const option = new Option(resp.name, resp.id, true, true);
            selectEl.append(option).trigger("change");
          },
          error: function () {
            // revert selection on failure
            selectEl.val(null).trigger("change");
            alert("Could not create campus.");
          },
        });
      }
    });

  $("[data-behavior=country-search-select2]").select2({
    placeholder: $(this).data("placeholder"),
    theme: "bootstrap",
    minimumInputLength: 3,
    ajax: {
      url: "/admin/countries",
      dataType: "json",
      delay: 250,
      data: (params) => ({
        search_term: params.term,
      }),
      processResults: function (data) {
        return {
          results: data.map((item) => ({ id: item, text: item })),
        };
      },
    },
  });
}
